module.exports = __webpack_public_path__ + "onboarding-steps.d8f7a03adb0006e6d5e1710f74f5ba8a.hashedasset.svg";